import axios from 'axios';

const axiosInstance =  axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
 });

 axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + process.env.REACT_APP_API_TOKEN
 
 export default axiosInstance